<template>
	<page title="Manage Clients">
		<template #actions>
			<create-client />
		</template>

		<clients-table :clients="clients" />
	</page>
</template>
<script>
import Backend from '@/Layouts/Backend'
import Page from '@/Pages/Backend/Components/Page'
import ClientsTable from '@/Pages/Backend/Clients/Table'
import CreateClient from '@/Pages/Backend/Clients/Create'

export default {
	components: { Page, ClientsTable, CreateClient },
	layout: Backend,
	props: {
		clients: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
